import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftRotationListItem = (props) => {
    const { rotation, updateBackgroundSettings } = props;

    const onRotationChange = (value) => updateBackgroundSettings({ drift: { rotation: value } });

    return (
        <SliderListItem
            title='Rotation'
            displayMultiplier={2.5}
            value={rotation}
            min={0}
            max={25}
            step={1}
            onValueChange={onRotationChange}
            toolTip='Maximum rotation in degrees.'
        />
    );
};

const mapStateToProps = (state) => {
    const { rotation } = state.createPreview.present.videoSettings.background.drift;
    return { rotation };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftRotationListItem);
